import React, { useState } from 'react';

const ResumeForm: React.FC = () => {
  const [profileImage, setProfileImage] = useState<any>(null);
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('wnsgur4364@naver.com'); // 예시 이메일
  const [university, setUniversity] = useState('한밭대학교'); // 대전 대학명
  const [major, setMajor] = useState('컴퓨터공학'); // 전공
  const [availability, setAvailability] = useState({
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: '',
  }); // 근무 가능 요일 및 시간
  const [transcript, setTranscript] = useState<any>(null); // 재학 증명서

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleChange = (day: string, time: string) => {
    setAvailability({
      ...availability,
      [day]: time,
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // 서버로 이력서 데이터를 제출하는 로직 추가
    console.log('이력서 데이터 제출:', { address, phone, email, profileImage, university, major, availability, transcript });
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-semibold text-center mb-6">이력서 작성</h1>

      {/* 프로필 사진 */}
      <div className="mb-6 flex items-center justify-center">
        <label className="mr-4 text-gray-700">프로필 사진</label>
        <div className="relative">
          <img
            src={profileImage || '/path/to/default-image.jpg'} // 기본 이미지 경로
            alt="프로필"
            className="w-24 h-24 rounded-full object-cover border-2 border-gray-300"
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="absolute bottom-0 right-0 opacity-0 w-8 h-8 cursor-pointer"
          />
        </div>
      </div>

      {/* 주소 입력 */}
      <div className="mb-6">
        <label htmlFor="address" className="block text-lg font-medium text-gray-700">주소</label>
        <input
          type="text"
          id="address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="주소를 입력하세요"
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      {/* 휴대폰 번호 입력 */}
      <div className="mb-6">
        <label htmlFor="phone" className="block text-lg font-medium text-gray-700">휴대폰 번호</label>
        <input
          type="tel"
          id="phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="휴대폰 번호를 입력하세요"
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      {/* 이메일 */}
      <div className="mb-6">
        <label htmlFor="email" className="block text-lg font-medium text-gray-700">이메일</label>
        <input
          type="email"
          id="email"
          value={email}
          disabled
          className="mt-2 p-3 w-full border rounded-md border-gray-300 bg-gray-100"
        />
      </div>

      {/* 대전 지역 대학 선택 */}
      <div className="mb-6">
        <label htmlFor="university" className="block text-lg font-medium text-gray-700">대학</label>
        <select
          id="university"
          value={university}
          onChange={(e) => setUniversity(e.target.value)}
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="한밭대학교">한밭대학교</option>
          <option value="충남대학교">충남대학교</option>
          <option value="목원대학교">목원대학교</option>
        </select>
      </div>

      {/* 전공 선택 */}
      <div className="mb-6">
        <label htmlFor="major" className="block text-lg font-medium text-gray-700">전공</label>
        <select
          id="major"
          value={major}
          onChange={(e) => setMajor(e.target.value)}
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="컴퓨터공학">컴퓨터공학</option>
          <option value="전자공학">전자공학</option>
          <option value="경영학">경영학</option>
          <option value="디자인">디자인</option>
          <option value="사회학">사회학</option>
        </select>
      </div>

      {/* 근무 가능 요일 및 시간 */}
      <div className="mb-6">
        <label htmlFor="availability" className="block text-lg font-medium text-gray-700">근무 가능 시간</label>
        <div className="grid grid-cols-2 gap-4">
          {['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'].map((day, idx) => (
            <div key={idx}>
              <label className="block text-sm font-medium text-gray-700">{day.charAt(0).toUpperCase() + day.slice(1)}</label>
              <select
                id={day}
                value={availability[day as keyof typeof availability]}
                onChange={(e) => handleChange(day, e.target.value)}
                className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">선택</option>
                <option value="오전 9시~12시">오전 9시~12시</option>
                <option value="오후 1시~5시">오후 1시~5시</option>
                <option value="교육 불가">교육 불가</option>
              </select>
            </div>
          ))}
        </div>
      </div>

      {/* 재학 증명서 업로드 */}
      <div className="mb-6">
        <label htmlFor="transcript" className="block text-lg font-medium text-gray-700">재학 증명서 업로드</label>
        <input
          type="file"
          id="transcript"
          accept="application/pdf"
          onChange={(e) => setTranscript(e.target.files && e.target.files[0])}
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>
      {/* 기타 증명서 업로드 */}
      <div className="mb-6">
        <label htmlFor="transcript" className="block text-lg font-medium text-gray-700">기타 증명서 업로드</label>
        <input
          type="file"
          id="transcript"
          accept="application/pdf"
          onChange={(e) => setTranscript(e.target.files && e.target.files[0])}
          className="mt-2 p-3 w-full border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      {/* 제출 버튼 */}
      <div className="flex justify-center">
        <button
          onClick={handleSubmit}
          className="px-6 py-3 text-white bg-indigo-600 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          이력서 제출
        </button>
      </div>
    </div>
  );
};

export default ResumeForm;
